exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mat-button.toggle-cb-btn {\n  font-weight: normal;\n  padding-left: 0;\n  font-family: Roboto, \"Helvetica Neue\", sans-serif !important;\n  font-size: 14px;\n  text-align: left;\n  width: 100%;\n  color: rgba(0, 0, 0, 0.87);\n  position: absolute;\n  left: 0;\n  padding-left: 45px;\n  top: 2.5px; }\n\n.loader_msg {\n  color: #5dd791; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/profile/future-operational-hours/future-operational-hours.scss
// module id = ../../../../../src/app/profile/future-operational-hours/future-operational-hours.scss
// module chunks = main